export const SSO_COOKIES = {
    programmeConnect2021: 'programmeconnect2021',
    programmeConnect2021Sales: 'programmeconnect2021_sales'
}

export const TYPE_MESSAGE_MAP = {
    device: {
        message: 'Sign in exceeded limit',
        description:
            'Each account is subject to a three-device limit. As you are now trying to link to a fourth device, please note that once you click “Continue”, your other three currently linked devices will be unlinked.'
    },
    3: {
        message: 'Your device has been unlinked.'
    },
    4: {
        message: 'Your account has been changed. Please login again.'
    },
    5: {
        message: 'Please enter a registered email to access the site.'
    },
    timeout: { message: 'Login request timeout, try again later' }
}

export const LOGIN_MODAL_TYPE = {
    LOGIN_TIPS: 'loginTips',
    LOGIN_ACTION: 'loginAction'
}
